// extracted by mini-css-extract-plugin
export default {"phoneCode":"TalentPhoneValue_phoneCode__q8Pd0","phoneNumber":"TalentPhoneValue_phoneNumber__LBHWb","muted":"TalentPhoneValue_muted__akLcI"};